module.exports = __webpack_public_path__ + "img/31.40d16f9d.jpg";